const index = () => import('./Index');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/china/v2022/index',
      name: 'china_v2022_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/china2025/V2022/router.js